import { PageLink as Link } from 'src/app/AppAuth/PageLink'
import styled from 'styled-components/macro'

export const DocumentsReadyCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
`
export const DocumentsReadyCheckHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  word-break: break-word;
`
export const AuditBotCheckBody = styled.div<{ $isFromControl?: boolean }>`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ $isFromControl }) => !$isFromControl && 'margin-left: 2em'};
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`
export const DocumentsReadyCheckLink = styled(Link)`
  text-decoration: none;
  font-weight: 500;
`

export const ControlCheckPassBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`
